import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UploadImageRequestPayload {
  file: File;
  mediaType?: 'image' | 'video';
}

interface ImageUploadState {
  status: "idle" | "uploading" | "success" | "error";
  uploadedImageUrl?: string;
  error?: string;
}

const initialState: ImageUploadState = {
  status: "idle",
};

const imageUploadSlice = createSlice({
  name: "imageUpload",
  initialState,
  reducers: {
    uploadImageRequest: (state, action: PayloadAction<File | UploadImageRequestPayload>) => {
      state.status = "uploading";
      state.error = undefined;
    },
    uploadImageSuccess: (state, action: PayloadAction<string>) => {
      state.status = "success";
      state.uploadedImageUrl = action.payload;
    },
    uploadImageFailure: (state, action: PayloadAction<string>) => {
      state.status = "error";
      state.error = action.payload;
    },
    clearUploadState: () => initialState,
  },
});

export const {
  uploadImageRequest,
  uploadImageSuccess,
  uploadImageFailure,
  clearUploadState,
} = imageUploadSlice.actions;

export default imageUploadSlice.reducer;
